export default "__VITE_ASSET__MsnBi5Z9__"